<template>
  <v-container fluid>
    <vue-advanced-chat
      :current-user-id="currentUserId"
      :username-options="JSON.stringify(cantUsuario)"
      :rooms="JSON.stringify(rooms)"
      :messages="JSON.stringify(messages)"
      :messages-loaded="messagesLoaded"
      :rooms-loaded="true"
      :show-audio="false"
      :show-search="false"
      :show-add-room="false"
      :single-room="isMobile"
      :show-footer="true"
      @open-file="openFile($event.detail[0])"
      @fetch-messages="buscarMensajes($event.detail[0])"
      @send-message="sendMessage($event.detail[0])"
    >
      <div
        v-if="this.logueado.cargo == 'Investigador'"
        class="room-header-info"
        slot="room-header-info"
      >
        <p style="margin: 0px"><b>Chat en proceso (Entrar)</b></p>
        <v-icon
          color="blue"
          icon
          text
          outlined
          @click="mostrarModalFotosDrone()"
          title="Fotos Drone"
          >mdi-quadcopter</v-icon
        >
      </div>
      <!-- <div slot="send-icon">
        <v-icon>mdi-send</v-icon>
      </div> -->
    </vue-advanced-chat>
    <modal-add-fotos-drone
      v-if="showModalFotosDrone"
      :showModal.sync="showModalFotosDrone"
      :id="idchat"
      :mensajes="messages"
      :latitud="coordenadas.latitude"
      :longitud="coordenadas.longitude"
      :casoid="idCaso"
      @actualizar="buscarSala"
    ></modal-add-fotos-drone>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db, ref, storage, uploadBytes, getDownloadURL } from "../../firebase";
// import { db } from "../../firebase";
import moment from "moment";
import ModalAddFotosDrone from "./ModalAddFotosDrone.vue";
// import ChatWindow from "vue-advanced-chat";
// import "vue-advanced-chat/dist/vue-advanced-chat.css";
import { saveAs } from "file-saver";
import { register } from "vue-advanced-chat";
register();

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Mensaje",
  components: {
    // ChatWindow,
    ModalAddFotosDrone,
  },
  async mounted() {
    // console.log(this.logueado);
    if (localStorage.getItem("user")) {
      // `logueado` puede tardar en hidratarse o venir null si localStorage está incompleto.
      if (!this.logueado || !this.logueado.id) {
        this.$store.commit("authData");
      }
      if (!this.logueado || !this.logueado.id) {
        this.handleError({
          message:
            "No se encontró la información del usuario en sesión. Cierra sesión e ingresa nuevamente.",
        });
        return;
      }
      this.currentUserId = this.logueado.id;
      if (this.logueado.cargo == "Abogado") {
        this.newMensaje.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fabogado.png?alt=media&token=fb33caa0-bd95-42b9-b5e7-f68c7787bb8a";
      } else if (this.logueado.cargo == "Investigador") {
        this.newMensaje.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Finvestigador.jpg?alt=media&token=f4e45f88-533c-43b4-9ff7-6facdd0456ea";
      } else {
        this.newMensaje.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fcall-center.png?alt=media&token=bb40e74f-9b28-4bd8-b4b5-6daf3d9353b6";
      }
    } else {
      this.currentUserId = localStorage.getItem("cliente");
      const datos = await db
        .collection("clientes")
        .doc(this.currentUserId)
        .get();
      this.logueado.nombres = datos.data()?.nombres;
      this.logueado.identificacion = datos.data()?.identificacion;
      this.logueado.cargo = "Cliente";
    }
    await this.buscarSala();
  },
  data() {
    return {
      users: [],
      cantUsuario: { minUsers: 2, currentUser: false },
      messagesLoaded: false,
      currentUserId: "",
      idCaso: this.$route.params.id,
      idchat: "",
      rooms: [],
      roomId: 1,
      messages: [],
      intento: 1,
      crearChat: {},
      newMensaje: {
        _id: "",
        indexId: "",
        senderId: "",
        username: "Calvo",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fcliente.jpg?alt=media&token=b294ad63-36d5-4e9a-ab44-afa5a1ee8f31",
        date: moment().format("DD/MM/YYYY HH:mm", Date.now()),
        timestamp: moment().format("DD/MM/YYYY HH:mm", Date.now()),
        system: false,
        saved: true,
        distributed: true,
        seen: true,
        deleted: false,
        disableActions: false,
        disableReactions: false,
        failure: false,
        content: "",
        roomId: "",
      },
      mensajes: [],
      nameArchivo: "",
      usersTokenPush: [],
      mensajeChat: "",
      showModalFotosDrone: false,
      coordenadas: {},
    };
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    isMobile() {
      return navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/BlackBerry/i)
        ? true
        : false;
    },
  },
  methods: {
    mostrarModalFotosDrone(item = {}) {
      try {
        if (!navigator.geolocation) {
          throw new Error("Geolocalización no soportada por este navegador");
        }
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log(
              `Latitud: ${position.coords.latitude}, Longitud: ${position.coords.longitude}`
            );
            this.coordenadas = position.coords;
          },
          (error) => {
            console.error("Error al obtener la ubicación:", error);
          }
        );
        console.log("Click");
        this.id = item?.id || null;
        this.showModalFotosDrone = true;
      } catch (error) {
        this.handleError(error);
      }
    },
    async buscarSala() {
      try {
        const datos = await db
          .collection("chats")
          .where("uidcaso", "==", this.$route.params.id)
          .get();
        console.log(datos.empty, "chat normal");
        if (datos.empty && this.intento <= 3) {
          await this.crearChatNormal();
          this.intento++;
          return await this.buscarSala();
        }
        if (datos.empty) {
          throw new Error(
            "No se encontró (ni se pudo crear) la sala de chat para este caso."
          );
        }

        const chat = await db.collection("chats").doc(datos.docs[0].id).get();
        this.rooms = [{ ...chat.data() }];
        this.idchat = this.rooms[0].roomId;
        // console.log(this.currentUserId, "ID USUARIO");
        if (this.rooms[0].users.some((el) => el._id === this.currentUserId))
          return;
        // console.log("agregar usuarios");
        this.rooms[0].users.push({
          _id: this.currentUserId,
          username:
            this.logueado?.nombres +
            this.logueado?.identificacion?.substr(0, 4) +
            "(" +
            this.logueado.cargo +
            ")",
          status: {
            state: "online",
          },
        });
        await db.collection("chats").doc(this.idchat).update(this.rooms[0]);
      } catch (error) {
        this.handleError(error);
      }
    },
    async crearChatNormal() {
      try {
        this.crearChat.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fvml.ico?alt=media&token=d93de8fc-dc76-4c53-bb6e-f8420d814827";
        this.crearChat.roomName = "Chat en proceso (Entrar)";
        this.crearChat.uidcaso = this.$route.params.id;
        this.crearChat.unreadCoun = 0;
        this.crearChat.users = [];

        const resChat = await db.collection("chats").add(this.crearChat);
        await db
          .collection("chats")
          .doc(resChat.id)
          .update({ roomId: resChat.id });
      } catch (error) {
        // Dejar que `buscarSala` maneje el error final.
        console.log(error);
      }
    },
    // consulta los ms del chat anterior
    // eslint-disable-next-line no-unused-vars
    async buscarMensajes({ room, options }) {
      try {
        db.collection("mensajes")
          .where("roomId", "==", room.roomId)
          .onSnapshot((snap) => {
            if (
              this.logueado.cargo == "Perito" ||
              this.logueado.cargo == "Coordinador Perito" ||
              this.logueado.cargo == "Dibujante"
            ) {
              this.mensajes = snap.docs
                .map((e) => e.data())
                .filter((el) => el.files && el.files.some((x) => !x.audio));
            } else {
              this.mensajes = snap.docs.map((e) => e.data());
            }
            this.messages = this.ordenarPorFechaEnvio(this.mensajes);
          });
        this.messagesLoaded = true;
      } catch (error) {
        this.handleError(error);
      }
    },
    fechaEnvioMs(mensaje = {}) {
      if (typeof mensaje.creado === "number") return mensaje.creado;
      const formatos = [
        "DD/MM/YYYY HH:mm:ss",
        "DD/MM/YYYY HH:mm",
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD HH:mm",
        moment.ISO_8601,
      ];
      // Algunas apps guardan `date` (día) y `timestamp` (hora) por separado.
      const candidatos = [
        mensaje.timestamp,
        mensaje.date,
        mensaje.date && mensaje.timestamp
          ? `${mensaje.date} ${mensaje.timestamp}`
          : null,
      ];
      for (const valor of candidatos) {
        if (!valor) continue;
        if (typeof valor.toDate === "function") return valor.toDate().getTime();
        if (typeof valor === "number") return valor;
        const fecha = moment(valor, formatos, true);
        if (fecha.isValid()) return fecha.valueOf();
      }
      return 0;
    },
    ordenarPorFechaEnvio(mensajes = []) {
      return [...mensajes].sort((a, b) => {
        const diferencia = this.fechaEnvioMs(a) - this.fechaEnvioMs(b);
        if (diferencia !== 0) return diferencia;
        if (typeof a._id === "number" && typeof b._id === "number") {
          return a._id - b._id;
        }
        return 0;
      });
    },
    async sendMessage({ content, roomId, files, replyMessage }) {
      // eslint-disable-next-line no-unreachable
      this.messagesLoaded = false;
      try {
        if (
          this.logueado.cargo == "Perito" ||
          this.logueado.cargo == "Coordinador Perito" ||
          this.logueado.cargo == "Coordinador Abogado CAIT" ||
          this.logueado.cargo == "Abogado CAIT" ||
          this.logueado.cargo == "Dibujante"
        ) {
          // console.log("Ingresa a esta validacion", this.logueado.cargo);
          throw new Error("Su rol no esta autorizado para esta acción");
        }
        if (files) {
          await this.cargarDocumentosChat(files);
        }
        if (replyMessage) {
          await this.responderMesanjes(replyMessage);
        }
        this.newMensaje.content = content;
        this.newMensaje.roomId = roomId;
        this.newMensaje._id = this.messages.length;
        this.newMensaje.indexId = this.messages.length;
        this.newMensaje.senderId = this.currentUserId;
        this.newMensaje.username =
          this.logueado.nombres +
          this.logueado.identificacion.substr(0, 4) +
          "(" +
          this.logueado.cargo +
          ")";
        this.newMensaje.date = moment().format("DD/MM/YYYY HH:mm", Date.now());
        this.newMensaje.timestamp = moment().format(
          "DD/MM/YYYY HH:mm",
          Date.now()
        );
        this.newMensaje.creado = Date.now();

        await db.collection("mensajes").add(this.newMensaje);
        // notificar a los usuarios que no estén conectados y que cuenten con token push
        await this.notificarMsj();
        this.newMensaje = {};
        this.messagesLoaded = true;
      } catch (error) {
        this.messagesLoaded = true;
        this.handleError(error);
      }
    },
    async notificarMsj() {
      this.usersTokenPush = [];
      this.mensajeChat = "";
      const { roomId, content: mensaje } = this.newMensaje;
      this.mensajeChat = mensaje;
      const objSala = await db
        .collection("chats")
        .where("roomId", "==", `${roomId}`)
        .get();

      const infoSala = objSala.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      if (!infoSala) {
        return true;
      }

      const { users } = infoSala[0];
      const objUsers = users.filter((user) => user.status.state === "offline");
      // Cliente
      const tokenCliente = await Promise.all(
        objUsers.map(async (c) => {
          const cliente = await db.collection("clientes").doc(c._id).get();
          if (cliente.data()) {
            const { tokenPush } = cliente.data();
            return tokenPush;
          }
          return "";
        })
      );

      //Usuarios
      const tokenUsuarios = await Promise.all(
        objUsers.map(async (u) => {
          const usuarios = await db.collection("usuarios").doc(u._id).get();
          if (usuarios.data()) {
            const { tokenPush } = usuarios.data();
            return tokenPush;
          }
        })
      );

      let usuCliente = tokenCliente.filter((u) => u);
      let usuDigipats = tokenUsuarios.filter((u) => u);

      if (usuCliente) {
        this.usersTokenPush = [...usuCliente];
      }

      if (usuDigipats) {
        this.usersTokenPush = [...this.usersTokenPush, ...usuDigipats];
      }

      // console.log(this.usersTokenPush);
      if (this.usersTokenPush) {
        await this.fechNotificaciones();
      }
    },
    async fechNotificaciones() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      let registration_ids = this.usersTokenPush;
      if (registration_ids.length <= 0) {
        return;
      }
      let message = this.mensajeChat;

      const dominio =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? "https://sandbox.digipats.com.co"
          : "https://digipats.com.co";
      const ambiente =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
          : process.env.VUE_APP_CLOUDFUNCTIONURL;
      const url = `${ambiente}/enviarNotificacionFcm`;

      const raw = JSON.stringify({
        tokens: [...registration_ids],
        message: {
          notification: {
            title: "Mensaje Chat",
            body: message,
          },
          data: {
            url: `${dominio}/gestionar-caso/${this.idCaso}`,
          },
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
    async cargarDocumentosChat(files) {
      this.messagesLoaded = true; // colocar en el evento del boton
      const arrayDoc = [];
      const archivos = await Promise.all(
        files.map(async (file) => {
          file.nameArchivo = Math.floor(Math.random() * 10000000) + Date.now();
          file.msExtension = file.extension || "mp3";
          const storageRef = ref(
            storage,
            `DocChat/${file.nameArchivo}.${file.msExtension}`
          );
          await uploadBytes(storageRef, file.blob);
          file.url = await getDownloadURL(
            ref(storage, `DocChat/${file.nameArchivo}.${file.msExtension}`)
          );
          return file;
        })
      );
      if (archivos) {
        archivos.map((file, i) => {
          arrayDoc.push({
            name: `${file.nameArchivo}`,
            size: `${file.size}`,
            type: `${file.type}`,
            url: `${file.url}`,
            extension: `${file.msExtension}`,
            preview: `${file.localUrl}`,
          });
          if (file.audio) {
            arrayDoc[i].audio = true;
            arrayDoc[i].duration = file.duration;
          }
        });
        this.newMensaje.files = arrayDoc;
      }
    },
    async responderMesanjes(replyMessage) {
      this.newMensaje.replyMessage = {
        _id: replyMessage._id,
        content: replyMessage.content,
        sender_id: replyMessage.senderId,
      };
      if (replyMessage.files) {
        this.newMensaje.replyMessage.files = replyMessage.files;
      }
    },
    openFile({ file }) {
      try {
        const extension = ["pdf", "docx", "doc", "xlsx", "xls"];
        if (
          this.logueado.cargo == "Abogado" ||
          this.logueado.cargo == "Call Center" ||
          this.logueado.cargo == "Perito" ||
          this.logueado.cargo == "Dibujante" ||
          this.logueado.cargo == "Administrador" ||
          this.logueado.cargo == "Coordinador Abogado" ||
          this.logueado.cargo == "Coordinador Contact Center" ||
          this.logueado.cargo == "Coordinador Investigador" ||
          this.logueado.cargo == "Coordinador Perito" ||
          this.logueado.cargo == "Investigador" ||
          this.logueado.cargo == "Cliente"
        ) {
          if (extension.includes(file.file.extension))
            window.open(file.file.url, "_blank");
          if (!extension.includes(file.file.extension))
            this.descargarImagen(file.file.url);
        } else {
          // console.log("Ingreso aqui");
          throw new Error(
            "Su rol no esta  autorizado para realizar esta acción"
          );
        }
      } catch (error) {
        this.handleError(error);
      }

      // window.open(file.file.url, "_blank");
    },
    descargarImagen(imageUrl) {
      fetch(imageUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              "Error al descargar la imagen: " +
                response.status +
                " " +
                response.statusText
            );
          }
          return response.blob();
        })
        .then((blob) => {
          saveAs(blob, "imagen.jpg");
        })
        .catch((error) => {
          console.error("Error al descargar la imagen:", error);
        });
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
#infinite-loader-rooms {
  display: none;
}
.room-header-info {
  display: flex;
  align-items: center;
  gap: 20px;
}
</style>
